module.exports = __webpack_public_path__ + "img/電気回路_4_10.e97bc3fc.png";